export enum AuctionStatus {
    New = "New",
    Live = "Live",
    Completed = "Completed"
}
